<template>
  <ImgView
    :src="imageUrl"
    :alt="alt"
    :itemprop="SCHEMA_ITEM_PROP.IMAGE"
    :width="width"
    :height="height"
    v-bind="$attrs"
  />
</template>

<script lang="ts">

import { getUrlWithResizeQuery } from '~~/helpers/twicpics/getUrlWithResizeQuery';
import { SCHEMA_ITEM_PROP } from '~~/constants/seo';
import type { TwicpicsMode } from '~~/types/twicpics/twicpics';
import { TWICPICS_MODE } from '~~/types/twicpics/twicpics';

export default defineComponent({
  name: 'TwicpicsImage',

  props: {
    src: {
      type: String,
      required: true,
    },
    alt: {
      type: String,
      default: '',
    },
    width: {
      type: Number,
      required: true,
    },
    height: {
      type: Number,
      required: true,
    },
    mode: {
      type: String as PropType<TwicpicsMode>,
      default: TWICPICS_MODE.CONTAIN,
    },
  },
  setup(props) {

    const imageUrl = computed(() => getUrlWithResizeQuery(props.src, {
      mode: props.mode,
      width: props.width,
      height: props.height,
    }));

    return {
      imageUrl,
      SCHEMA_ITEM_PROP,
    };
  
  },
});


</script>
